<template>
  <el-form label-width="110px" class="slot-manager-container">
    <el-form-item label="未识别话术：">
      <el-select v-model="item.btm_norec" placeholder="请选择">
        <el-option
          v-for="item in options1"
          :key="item.id"
          :label="item.btm_text"
          :value="item.btm_code"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="未响应话术：">
      <el-select v-model="item.btm_nores" placeholder="请选择">
        <el-option
          v-for="item in options2"
          :key="item.id"
          :label="item.btm_text"
          :value="item.btm_code"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="重试次数：">
      <el-input-number
        size="medium"
        v-model="item.retry_times"
        :min="0"
        @change="setRetryCout"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="异常触发：">
      <el-radio-group v-model="item.err_action" @change="changeRadio">
        <el-radio :label="1">无</el-radio>
        <el-radio :label="2">挂机</el-radio>
        <el-radio :label="3">转人工</el-radio>
        <el-radio :label="4">重播</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="异常话术：">
      <el-select v-model="item.err_code" placeholder="请选择">
        <el-option
          v-for="item in options3"
          :key="item.id"
          :label="item.btm_text"
          :value="item.btm_code"
        >
        </el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'
  import { getOutManagerList } from '@/api/setBase'
  export default {
    data() {
      return {
        options1: [], //未识别
        options2: [], // 未响应
        options3: [], //异常话术
      }
    },
    computed: {
      ...mapState({
        item: (state) => state.aimManager.slotForm,
      }),
    },
    mounted() {
      Promise.all([
        this.getLists('未识别'),
        this.getLists('未响应'),
        this.getLists(''),
      ]).then((res) => {
        this.options1 = res[0]
        this.options2 = res[1]
        this.options3 = res[2]
      })
    },
    methods: {
      ...mapMutations('aimManager', ['setSlotFormVal']),
      async getLists(btm_scene) {
        const res = await getOutManagerList({
          page: 1,
          pagesize: 1000,
          btm_scene,
        })
        return res.data.list
      },
      async changeRadio(e) {
        let text = ''
        switch (e) {
          case 1: {
            text = ''
            break
          }
          case 2: {
            text = '挂机'
            break
          }
          case 3: {
            text = '转人工'
            break
          }
          case 4: {
            text = '重播'
            break
          }
        }
        this.setSlotFormVal({
          err_action: e,
          err_code: '',
        })
        this.options3 = await this.getLists(text)
      },
      setRetryCout(e) {
        this.setSlotFormVal({ retry_times: e })
      },
    },
  }
</script>

<style lang="scss">
  .slot-manager-container {
    .el-select {
      width: 80%;
    }
  }
  .error-input {
    width: 80%;
  }
</style>
